import { Component, input, output } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'dhp-filter-accordion',
  templateUrl: './filter-accordion.html',
  imports: [TranslatePipe],
})
export class filterAccordion {
  //region Inputs
  // Name of the filter
  public readonly filterName = input.required<string>()
  //endregion Inputs

  //region Outputs
  // Emitted each time it opens, so its content can load on first use
  public readonly opened = output()
  //endregion Outputs

  //region Properties
  protected isAccordionOpen = false
  //endregion Properties

  //region Methods
  toggleAccordion(): void {
    this.isAccordionOpen = !this.isAccordionOpen
    if (this.isAccordionOpen) this.opened.emit()
  }
}
